import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['row', 'pilotButton', 'practiceButton', 'csvLink', 'noResults']
  static values = {
    csvBasePath: String
  }

  connect() {
    this.pilotFilterActive = false
    this.practiceFilterActive = false
    this.updateVisibility()
  }

  togglePilotFilter(event) {
    this.pilotFilterActive = !this.pilotFilterActive
    this.updateButtonStyling(event.currentTarget, this.pilotFilterActive)
    this.updateVisibility()
    this.updateCsvLink()
  }

  togglePracticeFilter(event) {
    this.practiceFilterActive = !this.practiceFilterActive
    this.updateButtonStyling(event.currentTarget, this.practiceFilterActive)
    this.updateVisibility()
    this.updateCsvLink()
  }

  updateButtonStyling(button, isActive) {
    if (isActive) {
      // Active state: indigo background, white text, no border
      button.classList.remove('bg-white', 'text-gray-900', 'ring-1', 'ring-inset', 'ring-gray-300', 'hover:bg-gray-50')
      button.classList.add('bg-indigo-600', 'text-white', 'hover:bg-indigo-500')
    } else {
      // Inactive state: white background, gray text, gray border
      button.classList.remove('bg-indigo-600', 'text-white', 'hover:bg-indigo-500')
      button.classList.add('bg-white', 'text-gray-900', 'ring-1', 'ring-inset', 'ring-gray-300', 'hover:bg-gray-50')
    }
  }

  updateVisibility() {
    let visibleCount = 0

    this.rowTargets.forEach(row => {
      const matchesPilot = !this.pilotFilterActive || row.dataset.status === 'Pilot'
      const matchesPractice = !this.practiceFilterActive || row.dataset.isPractice === 'true'

      if (matchesPilot && matchesPractice) {
        row.classList.remove('hidden')
        visibleCount++
      } else {
        row.classList.add('hidden')
        // Remove selection styling if row is filtered out
        row.classList.remove('bg-indigo-50', 'ring-2', 'ring-indigo-500')
      }
    })

    // Show/hide "no results" message
    if (this.hasNoResultsTarget) {
      if (visibleCount === 0) {
        this.noResultsTarget.classList.remove('hidden')
      } else {
        this.noResultsTarget.classList.add('hidden')
      }
    }
  }

  resetFilters() {
    this.pilotFilterActive = false
    this.practiceFilterActive = false

    // Update button styling
    if (this.hasPilotButtonTarget) {
      this.updateButtonStyling(this.pilotButtonTarget, false)
    }
    if (this.hasPracticeButtonTarget) {
      this.updateButtonStyling(this.practiceButtonTarget, false)
    }

    this.updateVisibility()
    this.updateCsvLink()
  }

  updateCsvLink() {
    if (!this.hasCsvLinkTarget) return

    const params = new URLSearchParams()

    if (this.pilotFilterActive) {
      params.append('pilot_filter', 'true')
    }

    if (this.practiceFilterActive) {
      params.append('practice_filter', 'true')
    }

    const queryString = params.toString()
    const baseUrl = this.csvBasePathValue || this.csvLinkTarget.href.split('?')[0]

    this.csvLinkTarget.href = queryString ? `${baseUrl}?${queryString}` : baseUrl
  }
}
